import { codemirror } from "vue-codemirror"
import '!style-loader!css-loader!codemirror/lib/codemirror.css'
import '!style-loader!css-loader!codemirror/theme/blackboard.css'
import '!style-loader!css-loader!./style.scss'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/keymap/sublime.js'
export default codemirror